.DataTileAnchor {
  text-decoration: none;
  color: inherit;

  & > div:hover {
    background-color: var(--bs-gray-100);
  }
}
